

  if (!customElements.get('fs-hero-slider')) {
    customElements.define('fs-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.slides = [...this.querySelectorAll('.fs-hero-slider__slide')];
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const hero = this.closest('.fenix-home__hero');
        const copy = hero.querySelector('.fenix-home__hero-copy');
        const actions = hero.querySelector('.fenix-home__actions');
        const micro = copy.querySelector('.fenix-home__micro');
        const mobileLayout = matchMedia('(max-width:749px)');
        const orderActions = () => { if (mobileLayout.matches) this.after(actions); else copy.insertBefore(actions, micro); };
        mobileLayout.addEventListener('change', orderActions, options);
        orderActions();
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.track = this.querySelector('.fs-hero-slider__slides');
        this.viewport = this.querySelector('.fs-hero-slider__viewport');
        const duplicate = slide => {
          const clone = slide.cloneNode(true);
          clone.dataset.clone = 'true'; clone.inert = true;
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelector('img').loading = 'eager';
          return clone;
        };
        this.track.prepend(duplicate(this.slides.at(-1)));
        this.track.append(duplicate(this.slides[0]));
        this.snap(1);
        this.track.addEventListener('transitionend', event => { if (event.target === this.track && event.propertyName === 'transform') this.settle(); }, options);
        // Load the next image before motion so the track never slides into a blank panel.
        this.slides.forEach(slide => { slide.querySelector('img').loading = 'eager'; });
        this.querySelector('.fs-hero-slider__controls').hidden = false;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => { this.pause(); this.show(this.index + Number(button.dataset.direction)); }, options));
        this.dots.forEach(button => button.addEventListener('click', () => { this.pause(); this.show(Number(button.dataset.slide)); }, options));
        this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.paused; }, options);
        this.toggle.addEventListener('pointercancel', () => { this.toggleIntent = undefined; }, options);
        this.toggle.addEventListener('click', () => { this.paused = this.toggleIntent ?? !this.paused; this.toggleIntent = undefined; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.pause(), options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, options);
        this.track.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') { this.pause(); this.origin = { x: event.clientX, y: event.clientY }; this.swiped = false; } }, options);
        this.track.addEventListener('pointerup', event => {
          if (!this.origin) return;
          const dx = event.clientX - this.origin.x;
          const dy = event.clientY - this.origin.y;
          this.origin = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.swiped = true; this.show(this.index + (dx < 0 ? 1 : -1)); }
        }, options);
        this.track.addEventListener('pointercancel', () => { this.origin = null; }, options);
        this.track.addEventListener('click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, options);
        this.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.pause(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); this.dots[this.index].focus(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .2 });
        this.observer.observe(this);
        this.schedule();
      }
      pause() { this.paused = true; this.schedule(); }
      snap(position) {
        this.track.style.transition = 'none';
        this.track.style.transform = `translateX(${-position * 100}%)`;
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
      settle() {
        clearTimeout(this.settleTimer);
        if (!this.moving) return;
        this.moving = false;
        if (this.boundary) this.snap(this.index + 1);
        this.boundary = false;
      }
      show(index) {
        if (this.moving) return;
        const count = this.slides.length;
        const next = (index + count) % count;
        if (next === this.index) { this.schedule(); return; }
        let position = next + 1;
        if (index === count) position = count + 1;
        if (index === -1) position = 0;
        this.boundary = position === 0 || position === count + 1;
        this.index = next;
        this.moving = !this.motion.matches;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== this.index;
          slide.setAttribute('aria-hidden', String(i !== this.index));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
        if (this.motion.matches) this.snap(next + 1);
        else {
          this.track.style.transform = `translateX(${-position * 100}%)`;
          this.settleTimer = setTimeout(() => this.settle(), 750);
        }
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        this.track.setAttribute('aria-live', 'off');
        if (!this.paused && !this.hovered && this.visible && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 5000);
      }
      disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.settleTimer); this.querySelectorAll('[data-clone]').forEach(clone => clone.remove()); this.observer?.disconnect(); this.abort?.abort(); this.abort = null; }
    });
  }
